var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoute(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.024,
    height: 40.024,
    viewBox: "0 0 40.024 40.024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_187496",
    "data-name": "Group 187496",
    transform: "translate(-15 -16.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37627",
    "data-name": "Path 37627",
    d: "M10.006,0H30.018A10.006,10.006,0,0,1,40.024,10.006V30.018A10.006,10.006,0,0,1,30.018,40.024H10.006A10.006,10.006,0,0,1,0,30.018V10.006A10.006,10.006,0,0,1,10.006,0Z",
    transform: "translate(15 16.26)",
    fill: "#fbf2ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_187422",
    "data-name": "Group 187422",
    transform: "translate(-199 -107.481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185946",
    "data-name": "Group 185946",
    transform: "translate(226 131.192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185947",
    "data-name": "Group 185947"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18052",
    "data-name": "Path 18052",
    d: "M3.066,24.682c-.179-.047-.359-.088-.536-.142A3.737,3.737,0,0,1,.01,20.673a3.576,3.576,0,0,1,3.05-3.432c.806-.082,1.622-.034,2.434-.045.092,0,.184,0,.293,0v-1.65a11.973,11.973,0,0,1-1.316-.369A6.589,6.589,0,0,1,.23,9.4,10.017,10.017,0,0,1,.191,8.248q-.005-2.9,0-5.807A2.431,2.431,0,0,1,1.752.075C1.825.05,1.9.033,2.018,0V.862c0,.134-.007.269,0,.4a.66.66,0,0,1-.172.507,1.087,1.087,0,0,0-.241.626c-.009,2.262-.05,4.527.028,6.786A5.069,5.069,0,0,0,5.516,13.92a4.945,4.945,0,0,0,5.8-4.557,6.437,6.437,0,0,0,.032-.753c0-1.986,0-3.972,0-5.958A1.075,1.075,0,0,0,11,1.742.217.217,0,0,1,10.93,1.6c-.005-.492,0-.985,0-1.51a2.269,2.269,0,0,1,1.7,1.6,3.2,3.2,0,0,1,.132.936c.011,1.986.007,3.972.006,5.958a6.663,6.663,0,0,1-5.463,6.9.527.527,0,0,0-.078.028V17.2H7.49c1.5,0,3-.021,4.5.007a2.961,2.961,0,0,0,2.557-1.067l1.474.362a3.844,3.844,0,0,1-.825,1.087,3.98,3.98,0,0,1-2.784,1.125q-4.386.009-8.773.007a2.053,2.053,0,0,0-1.876.983A2.243,2.243,0,0,0,3.2,23.134a2.142,2.142,0,0,0,1.928-.556,2.273,2.273,0,0,0,.672-1.6c.007-.233,0-.466,0-.716H7.175A3.76,3.76,0,0,1,4.333,24.63c-.067.013-.133.035-.2.052Z",
    transform: "translate(0 0.442)",
    fill: "#61277f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18053",
    "data-name": "Path 18053",
    d: "M.684,0A.685.685,0,1,1,0,.683.685.685,0,0,1,.684,0",
    transform: "translate(15.295 13.41)",
    fill: "#61277f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18054",
    "data-name": "Path 18054",
    d: "M1.1,0V1.473A1.806,1.806,0,0,1,.487,1.43.736.736,0,0,1,.714,0C.838,0,.963,0,1.1,0",
    transform: "translate(7.335 0)",
    fill: "#61277f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18055",
    "data-name": "Path 18055",
    d: "M0,.007a3.359,3.359,0,0,1,.455,0,.722.722,0,0,1,.629.738.722.722,0,0,1-.652.717,3.869,3.869,0,0,1-.432,0Z",
    transform: "translate(3.57 0.001)",
    fill: "#61277f"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.d5983da0b5db9c3c5f01134887017e9c.svg";
export { ForwardRef as ReactComponent };